import type { MessageKeys, NestedKeyOf } from "next-intl";

export const symbolPaletteKeys = {
  GREEK_ALPHABET: "greek-alphabet",
  OPERATORS: "operators",
  RELATIONSHIP_OPERATORS: "relationship-operators",
  CALCULUS: "calculus",
  DOUBLE_STROKE: "double-stroke",
  ARROWS: "arrows",
  LOGIC: "logic",
  SET: "set",
  OTHER: "other",
  CIRCLED: "circled",
  SERIF: "serif",
  ITALIC: "italic",
  GREEK_ITALIC: "greek-italic",
  SCRIPT: "script",
} as const;

type SymbolPaletteItemK = keyof typeof symbolPaletteKeys;
export type SymbolPaletteItemKey = (typeof symbolPaletteKeys)[SymbolPaletteItemK];

export type SymbolPaletteIntlName = MessageKeys<IntlMessages, NestedKeyOf<IntlMessages>>;

export type SymbolPaletteItem = {
  key: SymbolPaletteItemKey;
  nameIntlKey: SymbolPaletteIntlName;
  shortNameIntlKey?: SymbolPaletteIntlName;
  symbol?: string;
};
